import { Platform } from 'react-native';

export const useLocationPermissionPrimerEnabled = () => {
  return { canEnableLocationPrimer: Platform.OS !== 'web' };
};
